module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceShippingMethodsRenderModule",
    "path": "front/piece-shipping-methods-render.module"
  },
  "definition": {
    "name": "PieceShippingMethodsDefinition",
    "group": "Components",
    "availablePlatforms": ["web", "apps"],
    "description": "Métodos de envío",
    "fields": []
  }
};
